import cartHelper from '../../../../helpers/cart';
import transactionApi from '../../../../api/transaction';
import cartApi from '../../../../api/cart';
import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../../mutation-types';

const defaultState = () => ({
    cart: cartHelper.getUserCartData(),
    isAttempting: false,
    alerts: '',
    fieldErrors: {},
    step: 1,
    cartOne: '',
    courServiceList: 'error',
    courSelected: {},
    paymentSuccess: false,
    orderData: {},
    registerItem: {
        is_register: true,
        title: "",
        quantity: "",
        unit: "",
        price: 0,
        price_total: 0
    },
    alertMandatory: {
        sponsor: '',
        ktp: '',
        phone: '',
    },
    Step3ErorMessage: '',
    sponsorMLM: {},
});

const state = defaultState();

const getters = {
    cart() {
        return state.cart;
    },
    alertMandatory() {
        return state.alertMandatory;
    }
};

const actions = {
    async validateData({ commit, dispatch, state }, data) {
        if (!data.sponsor) {
            commit('setAlertMandatory', { code: 'sponsor', value: 'Tidak Boleh Kosong' })
        } else {
            commit(PROGRESS_START, null, { root: true });
            await cartApi.checkSponsor(data.sponsor).then(({data: { data }}) => {
                commit('setSponsorMLM', data)
                commit('setAlertMandatory', { code: 'sponsor', value: '' })
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                commit('setSponsorMLM', {})
                const { data } = err.response;
                commit('setAlertMandatory', { code: 'sponsor', value: data.message })
                commit(PROGRESS_FAIL, null, { root: true });
            })
        }

        if (!data.ktp) {
            commit('setAlertMandatory', { code: 'ktp', value: 'Tidak Boleh Kosong' })
        } else {
            commit(PROGRESS_START, null, { root: true });
            await cartApi.checkMandatory('ktp', data.ktp).then(() => {
                commit('setAlertMandatory', { code: 'ktp', value: '' })
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                commit('setAlertMandatory', { code: 'ktp', value: data.message })
                commit(PROGRESS_FAIL, null, { root: true });
            })
        }

        if (!data.phone) {
            commit('setAlertMandatory', { code: 'phone', value: 'Tidak Boleh Kosong' })
        } else {
            commit(PROGRESS_START, null, { root: true });
            await cartApi.checkMandatory('hp', data.phone).then(() => {
                commit('setAlertMandatory', { code: 'phone', value: '' })
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response;
                commit('setAlertMandatory', { code: 'phone', value: data.message })
                commit(PROGRESS_FAIL, null, { root: true });
            })
        }
        var dataAlert = Object.assign({}, state.alertMandatory)
        var alert = Object.values(dataAlert)
        var find = alert.find(el => el)
        if (!find) {
            commit('set_step', 2)
            dispatch('stockist/getStockistDetail', data.stockist_code, { root: true })
            dispatch('searchCart', data.stockist_code)
        }
    },
    async checkCart({ commit, dispatch, state }, cart) {
        if (!cart) {
            commit('updateCart');
            cart = state.cart
        }
        commit(PROGRESS_START, null, { root: true });
        commit('setAlert', '')
        await cartApi.checkCart({ cart: cart }).then(({ data: { data } }) => {
            commit('setCart', data.cart)
            if (data.is_member == false) {
                dispatch('auth/logout', null, { root: true });
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    saveCart({ commit, state }, data) {
        let tempCart = []
        state.alerts = '';
        if (state.cart) {
            tempCart = [...state.cart]
        }
        let indexStockist = tempCart.findIndex(x => x.stockist_code == data.stockist_code)
        if (indexStockist < 0) {
            if (parseInt(data.products.stock_store) < parseInt(data.products.quantity)) {
                state.alerts = 'Stok tersedia ' + data.products.stock_store;
            } else {
                let tempData = {
                    stockist_code: data.stockist_code,
                    stockist_network_id: data.stockist_id,
                    stockist_name: data.stockist_name,
                    stockist_prov: data.stockist_prov,
                    stockist_city: data.stockist_city,
                    products: [data.products],
                    price_total: parseInt(data.products.quantity) * parseInt(data.products.product_price),
                };
                // tempCart.push(tempData)
                tempCart[0] = tempData
            }
        } else {
            let indexProduct = tempCart[indexStockist].products.findIndex(x => x.product_id == data.products.product_id)
            if (indexProduct < 0) {
                tempCart[indexStockist].products.push(data.products)
            } else {
                let total_product_qty = parseInt(tempCart[indexStockist].products[indexProduct].quantity) + parseInt(data.products.quantity);
                if (total_product_qty <= parseInt(tempCart[indexStockist].products[indexProduct].stock_store)) {
                    tempCart[indexStockist].products[indexProduct].quantity = parseInt(tempCart[indexStockist].products[indexProduct].quantity) + parseInt(data.products.quantity)
                } else {
                    state.alerts = 'Stok tersedia ' + (parseInt(data.products.stock_store) - parseInt(tempCart[indexStockist].products[indexProduct].quantity));
                }
            }
            let price_total = 0
            tempCart[indexStockist].products.forEach(el => {
                price_total += parseInt(el.product_price) * parseInt(el.quantity)
            });
            tempCart[indexStockist].price_total = price_total
        }
        commit('setCart', tempCart)
    },
    deleteCart({ commit, state, dispatch }, data) {
        let tempCart = [...state.cart]
        let indexStockist = tempCart.findIndex(x => x.stockist_code == data.stockist_code)
        if (data.product_id) {
            let indexProduct = tempCart[indexStockist].products.findIndex(x => x.product_id == data.product_id)
            tempCart[indexStockist].products.splice(indexProduct, 1)
            if (tempCart[indexStockist].products.length == 0) {
                tempCart.splice(indexStockist, 1)
            }
        } else {
            tempCart.splice(indexStockist, 1)
        }
        cartHelper.setCartData(tempCart);
        dispatch('checkCart', tempCart)
        commit('setpaymentSuccess', false)
    },
    searchCart({ commit, state }, data) {
        let tempCart = [...state.cart]
        let indexStockist = tempCart.findIndex(x => x.stockist_code == data)
        let cart = tempCart[indexStockist]
        commit('setCartOne', cart)
    },
    getOngkir({ commit, dispatch }, param) {
        commit(PROGRESS_START, null, { root: true });

        transactionApi.getOngkir(param).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('defineCourServiceList', 'error');
            } else {
                commit('defineCourServiceList', data.results);
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            commit('cart/defineCourServiceList', 'error', { root: true });
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    getRegisterItem({ commit, dispatch }) {
        transactionApi.itemRegister().then(({ data: { data } }) => {
            commit('defineRegister', data);
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },
    postPickup({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        commit('attempting')
        commit('Step3ErorTittle', '');
        if (!value.member) {
            transactionApi.pickupPublic(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit('setpaymentSuccess', true)
                commit('step_up')
                commit(PROGRESS_FINISH, null, { root: true });
                commit('attempted')
            }).catch((err) => {
                commit(PROGRESS_FAIL, null, { root: true });
                commit('attempted')
                const { data } = err.response;
                if (data.message == 'error_validation') {
                    commit('Step3ErorTittle', 'Periksa kembali data yang anda kirim');
                } else {
                    commit('Step3ErorTittle', data.message);
                }
                dispatch('errorHandler', data);
            });
        } else {
            transactionApi.pickupMember(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit('setpaymentSuccess', true)
                commit('step_up')
                commit(PROGRESS_FINISH, null, { root: true });
                commit('attempted')
            }).catch((err) => {
                commit('attempted')
                const { data } = err.response;
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        }
    },
    postShipping({ commit, dispatch }, value) {
        commit(PROGRESS_START, null, { root: true });
        commit('attempting')
        commit('Step3ErorTittle', '');
        if (!value.member) {
            transactionApi.shippingPublic(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit('setpaymentSuccess', true)
                commit('step_up')
                commit('attempted')
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                commit('attempted')
                const { data } = err.response;
                if (data.message == 'error_validation') {
                    commit('Step3ErorTittle', 'Periksa kembali data yang anda kirim');
                } else {
                    commit('Step3ErorTittle', data.message);
                }
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        } else {
            transactionApi.shippingMember(value.params).then(({ data: { data } }) => {
                commit('saveOrderData', data);
                commit('setpaymentSuccess', true)
                commit('step_up')
                commit('attempted')
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                commit('attempted')
                const { data } = err.response;
                if (data.message == 'error_validation') {
                    commit('Step3ErorTittle', 'Periksa kembali data yang anda kirim');
                } else {
                    commit('Step3ErorTittle', data.message);
                }
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        }
    },
    errorHandler({ commit }, res) {
        switch (res.message) {
            case 'error_validation':
            commit('validationError', res.data)
            break;
            default:
            commit('setAlert', res.message)
            break;
        }
    }
}

const mutations = {
    setAlertMandatory(state, data) {
        state.alertMandatory[data.code] = ''
        state.alertMandatory[data.code] = data.value
    },
    setSponsorMLM(state, data) {
        state.sponsorMLM = data
    },
    saveOrderData(state, data) {
        state.orderData = Object.assign({}, state.orderData, data);
    },
    Step3ErorTittle(state, data) {
        state.Step3ErorMessage = data
    },
    setpaymentSuccess(state, data) {
        state.paymentSuccess = data
    },
    resetStep(state) {
        state.step = 1
    },
    defineCourServiceList(state, data) {
        state.courServiceList = data;
    },
    resetCourServiceList(state) {
        state.courServiceList = []
    },
    defineRegister(state, data) {
        state.registerItem = data;
    },
    selectCourier(state, data) {
        state.courSelected = Object.assign({}, state.courSelected, data);
    },
    resetCourier() {
        state.courSelected = '';
    },
    set_step(state, data) {
        state.step = data
    },
    step_up(state) {
        state.step++
    },
    step_down(state) {
        state.step--
    },
    attempting(state) {
        state.isAttempting = true;
        state.alerts = '';
        state.fieldErrors = {};
    },
    setAlert(state, data) {
        state.alerts = data;
    },
    resetAlert(state) {
        state.alerts = '';
    },
    attempted(state) {
        state.isAttempting = false;
    },
    validationError(state, errors) {
        state.fieldErrors = Object.assign({}, state.fieldErrors, errors);
    },
    setCart(state, cartData) {
        cartHelper.setCartData(cartData);
        state.cart = cartHelper.getUserCartData();
        state.fieldErrors = {};
    },
    updateCart(state) {
        state.cart = cartHelper.getUserCartData();
    },
    setCartOne(state, cart) {
        state.cartOne = Object.assign({}, state.cartOne, cart);
    },
    clearData() {
        cartHelper.clearCartData();
    },
    reset(state) {
        Object.assign(state, defaultState());
    },
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};